import ApiService from "@/common/api/api.service";

export const InvoiceService = {

    list_categories(slug='') {
        ApiService.setHeader()
        return ApiService.get('services/categories', slug)
    },
    list() {
        ApiService.setHeader()
        return ApiService.get(`services/simple`)
    },
    listBM(id) {
        ApiService.setHeader()
        return ApiService.get(`/bm/${id}/services/simple`)
    },

    search(page=1, itemsPerPage=10,accountType="", account="", search="", orderBy = "", sortDesc = "", startDate="", endDate="") {
        ApiService.setHeader()
        return ApiService.get(`invoices?page=${page}&itemsPerPage=${itemsPerPage}&account${accountType}=${account}&search=${search}&orderBy=${orderBy}&sortDesc=${sortDesc}&startDate=${startDate}&endDate=${endDate}`)
    },

    get(slug) {
        ApiService.setHeader()
        return ApiService.get('services', slug)
    },
    bmServices(slug) {
        ApiService.setHeader()
        return ApiService.get(`/bm/${slug}/services`, "")
    },

    create(data) {
        ApiService.setHeader()
        return ApiService.post('services', data)
    },
    update(slug, data) {
        ApiService.setHeader()
        return ApiService.update('services', slug, data)
    },
    active(id) {
        ApiService.setHeader()
        return ApiService.update(`services/${id}/active`)
    },
    inactive(id) {
        ApiService.setHeader()
        return ApiService.update(`services/${id}/inactive`)
    },

    delete(id) {
        ApiService.setHeader()
        return ApiService.delete(`services/${id}`)
    }
}